import { Button, Heading, Text } from '../index.spark';
import type { MediaCardProps } from './types';

export function MediaCard({
  title,
  description,
  action,
  headingLevel,
  imgSrc,
  imgFit = 'cover',
  buttonClassName,
}: MediaCardProps) {
  return (
    <section className="flex h-full flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow sm:flex-row">
      <img
        alt=""
        className={
          imgFit === 'contain'
            ? 'h-32 w-full min-w-0 bg-gray-100 object-contain object-center sm:h-full sm:w-1/4'
            : 'h-32 w-full min-w-0 object-cover object-center sm:h-full sm:w-1/4'
        }
        src={imgSrc}
      />
      <div className="flex flex-1 shrink-0 flex-col gap-1.5 p-4">
        <Heading style="sm" level={headingLevel}>
          {title}
        </Heading>
        <Text size="md" variant="secondary">
          {description}
        </Text>
        <div className="mt-auto">
          <Button
            className={buttonClassName}
            variant="secondary"
            onClick={action.onClick}
            icon={action.icon}
          >
            {action.content}
          </Button>
        </div>
      </div>
    </section>
  );
}
